import { render, staticRenderFns } from "./cognito.vue?vue&type=template&id=542974d1&scoped=true&"
import script from "./cognito.vue?vue&type=script&lang=js&"
export * from "./cognito.vue?vue&type=script&lang=js&"
import style0 from "./cognito.vue?vue&type=style&index=0&id=542974d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542974d1",
  null
  
)

component.options.__file = "cognito.vue"
export default component.exports